export const DOMAINS = {
  skiandnight: 'skiandnight',
  sbspain: 'sbspain',
  pokerRed: 'poker-red',
  euchis2026: 'euchis2026',
  default: 'default',
};

const DATA_PAGES = {
  [DOMAINS.skiandnight]: {
    title: 'home.banner.title',
    subTitle: 'home.banner.subtitle',
    titleAgrupaciones: 'home.festivales.title',
    subTitleAgrupaciones: 'home.festivales.subtitle',
    alternative: 'home.banner.experienciasAnyo',
    textBtn: 'home.banner.experienciasAMedida',
    textBtnExperiencias: 'alojamiento.todasExperiencias',
    textBtnCatalogo: 'home.banner.experienciasAnyo',
  },
  [DOMAINS.sbspain]: {
    title: 'home.banner.titleBsspain',
    titleAgrupaciones: 'home.festivales.titleBsspain',
    subTitleAgrupaciones: 'home.festivales.subtitleBsspain',
    domain: DOMAINS.sbspain,
    textBtn: null,
    textBtnExperiencias: 'alojamiento.todasExperiencias',
    textBtnCatalogo: 'home.banner.eligeTuEvento',
  },
  [DOMAINS.pokerRed]: {
    title: 'home.banner.titlePr',
    titleAgrupaciones: 'home.festivales.titlePr',
    subTitleAgrupaciones: 'home.festivales.subtitlePr',
    domain: DOMAINS.pokerRed,
    textBtn: 'home.buscadorSection.button',
    textBtnExperiencias: 'general.reservar',
    textBtnCatalogo: 'home.banner.experienciasAnyo',
  },
  [DOMAINS.euchis2026]: {
    title: '',
    titleAgrupaciones: 'home.festivales.titleEuchis2026',
    subTitleAgrupaciones: 'home.festivales.subtitleEuchis2026',
    domain: DOMAINS.euchis2026,
    textBtn: null,
    textBtnExperiencias: 'home.banner.experiencias',
    textBtnCatalogo: 'home.banner.experiencias',
  },
  [DOMAINS.default]: {
    title: '',
    titleAgrupaciones: 'home.festivales.titleDefault',
    subTitleAgrupaciones: 'home.festivales.subtitleDefault',
    domain: DOMAINS.default,
    textBtn: null,
    textBtnExperiencias: 'home.banner.experiencias',
    textBtnCatalogo: 'home.banner.experiencias',
  },
};

export const getPageData = () => {
  const domain =
    [DOMAINS.sbspain, DOMAINS.pokerRed, DOMAINS.skiandnight, DOMAINS.euchis2026].find(domain => checkDomain(domain)) ||
    DOMAINS.default;
  return DATA_PAGES[DOMAINS[domain]];
};

export function checkDomain(domains) {
  const domainsArray = Array.isArray(domains) ? domains : [domains];

  return domainsArray.some(domain => window.location.host.includes(domain));
}
